<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('已布置作业') }}</h4>
            <div class="flex flex-v-center">
                <el-input style="border-radius: 20px;" :placeholder="$t('请输入作业名称')" v-model="input3">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
        </div>

        <el-table :header-cell-style="{ background: '#f5f7fa', color: '#333', 'border-radius': '4px' }" class="margin-t"
            :data="tableData" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有已布置作业数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column prop="clazz.name" :label="$t('班级名称')">
            </el-table-column>
            <el-table-column prop="title" :label="$t('作业标题')">
            </el-table-column>
            <el-table-column prop="teacher.name" :label="$t('布置老师')">
            </el-table-column>

            <el-table-column prop="records_count" :label="$t('提交人数')">
            </el-table-column>
            <el-table-column prop="reviews_count" :label="$t('待批改作业')">
            </el-table-column>
            <el-table-column prop="created_at" :label="$t('创建时间')">
            </el-table-column>

            <el-table-column prop="expiry_time" :label="$t('截止时间')">
            </el-table-column>

            <el-table-column prop="address" :label="$t('操作')">
                <template>
                    <el-button size="mini" type="primary" @click="to('/main/teacher/class/detail')">{{ $t('查看')
                        }}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>


<script>
export default {
    data() {
        return {
            tableData: []
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.$http.post('/api/work/list', { name: this.name }).then(data => {
                this.tableData = data;
            });
        },
        to(path) {
            this.$router.push(path);
        }
    }
};
</script>
